// vue import
import "es6-promise/auto";

// modules import
import newUsers from "./modules/newUsers";

import router from "../router";
import { ERequestType, fetchGetHelper } from "../tools/fetch";
import calendar from "./modules/calendar";
import cash from "./modules/cash";
import discount from "./modules/discount";
import displayer from "./modules/displayer";
import events from "./modules/events";
import forkBooking from "./modules/forkBooking";
import infos from "./modules/infos";
import newClients from "./modules/newClients";
import newReservations from "./modules/newReservations";
import newRooms from "./modules/newRooms";
import newServices from "./modules/newServices";
import serviceWorker from "./modules/serviceWorker";
import stats from "./modules/stats";
import webSockets from "./modules/webSockets";

// for debug
// import createLogger from 'vuex/dist/logger'

// store db collection in rootState
const state = {
	appVersion: "",
	ipList: [],
	unreadNotif: 0,
};

const getters = {
	getAppVersion: function (state, getters) {
		return state.appVersion;
	},

	getLoadingState: function (state, getters) {
		let loaded = false;
		if (getters["newUsers/getUser"] !== null) {
			// Loading for app
			if (getters["newServices/getServicesIsLoaded"] && getters["newRooms/getStoreRoomsIsLoaded"] && getters["infos/getInfosIsLoaded"]) {
				loaded = true;
			}
		} else {
			// Loading for login
			loaded = true;
		}
		return loaded;
	},
};

const mutations = {
	setAppVersion: function (state, dbData) {
		state.appVersion = dbData;
	},
	setIpList: function (state, dbData) {
		state.ipList = dbData;
	},
};

const actions = {
	// TODO: refactor this two functions
	loadStoreModules: function ({ state, rootState, commit, dispatch, getters }) {
		let route = router.currentRoute.name;
		// connect to mongodb
		dispatch("newUsers/login")
			.then(() => {
				dispatch("calendar/initDay").then(() => {
					dispatch("newRooms/loadRoomsStore").then(() => {
						dispatch("events/loadEventsStore").then(() => {
							dispatch("discount/loadDiscountStore").then(() => {
								dispatch("newServices/loadServicesStore").then(() => {
									dispatch("newServices/loadlockedDays");
									dispatch("newRooms/loadlockedRooms");
									dispatch("newRooms/loadlockedTables");
									if (route !== "facebook" && route !== "permanance" && route !== "site web" && route !== "PRedirect") {
										dispatch("newReservations/syncRTCurrentResas").then(() => {
											dispatch("newReservations/syncAllResas");
											if (getters["serviceWorker/getResaToLoad"]) {
												setTimeout(() => {
													dispatch("serviceWorker/loadResaToLoad");
												}, 5000);
											}
										});
									} else if (route === "PRedirect") {
										// only sync current day
										dispatch("newReservations/syncRTCurrentResas").then(() => {
											dispatch("newClients/loadClients");
										});
									}
								});
							});
						});
					});
					dispatch("infos/loadInfos");
					dispatch("cash/loadCashDays");
				});
				// version app checker
				fetchGetHelper(ERequestType.APPINFOS.GET).then((res) => {
					commit("setAppVersion", res.data.version);
				});
			})
			.catch((err) => {
				console.error("Connection to mongoDB error", err);
				dispatch("newUsers/logout");
			});
	},
	checkAppVersion: function ({ state, rootState, commit, dispatch, getters }) {
		fetchGetHelper(ERequestType.APPINFOS.GET).then((res) => {
			if (state.appVersion !== "" && state.appVersion !== res.data.version) dispatch("updateAppOn");
		});
		dispatch("newUsers/checkUserStillValid");
	},
	loadIpsAuthorised: function ({ state, rootState, commit, dispatch }) {
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.APPINFOS.GET)
				.then((res) => {
					commit("setIpList", res.data.ips);
					resolve(res.data.ips);
				})
				.catch(function (error) {
					console.error("loadIpsAuthorised - Error getting documents: ", error, "NEED TO RELOAD");
				});
		});
	},
	async loadIpsCheckEnabeld({ state, rootState, commit, dispatch }) {
		return new Promise(async (resolve, reject) => {
			await fetchGetHelper(ERequestType.APPINFOS.GET)
				.then((res) => {
					resolve(res.data.ipsCheck);
				})
				.catch(function (error) {
					console.error("loadIpsAuthorised - Error getting documents: ", error, "NEED TO RELOAD");
				});
		});
	},
	loadPublicStoreModules: function ({ state, rootState, commit, dispatch }, eventid = null) {
		dispatch("calendar/initDay").then(() => {
			dispatch("infos/loadInfos");
			dispatch("newServices/loadlockedDays").then(() => {
				if (eventid) {
					dispatch("newServices/loadOnlyEventsById", eventid);
				} else {
					dispatch("events/loadEventsStoreVisible").then(() => {
						dispatch("newServices/loadServicesStore");
					});
				}
			});
		});
	},
	resetAllStore: function ({ state, rootState, commit, dispatch }) {
		return new Promise((resolve, reject) => {
			commit("calendar/resetStore");
			dispatch("newClients/cleanStore");
			commit("displayer/resetStore");
			dispatch("newReservations/cleanStore");
			dispatch("newRooms/cleanStore");
			dispatch("newServices/cleanStore");
			dispatch("infos/cleanStore");
			dispatch("cash/cleanStore");
			resolve("done");
		});
	},
	updateAppOn: function ({ state, rootState, commit, dispatch }) {
		// unregister serviceworker for clean cache
		navigator.serviceWorker.getRegistrations().then(function (registrations) {
			return Promise.all(
				registrations.map(function (reg) {
					return reg.unregister();
				}),
			);
		});
		// dispatch alert message
		commit("displayer/setUpdateAppAlerte", true);
	},
};

export default {
	state,
	getters,
	mutations,
	actions,
	modules: {
		stats,
		forkBooking,
		discount,
		newUsers,
		calendar,
		webSockets,
		newRooms,
		newClients,
		newServices,
		events,
		newReservations,
		infos,
		cash,
		displayer,
		serviceWorker,
	},
};
